import USBIconArrowLeft from '@usb-shield/react-icons/dist/esm/icon-arrow-left'
import { USBIconModalClose } from '@usb-shield/react-icons/dist/esm'
import { useReactiveVar } from '@apollo/client'
import USBMobileHeader from '../../components/mobile-header/index'
import { appCache } from '../../context/appCache'

const MobileBillPayLayout = () => {
  // const { headerConfig } = useHeader() TODO based on the routing have to set the page title accordingly and left and righticon
  const { Title, backActionData } = useReactiveVar(appCache)
  const { showBackButton } = backActionData || {}
  const pageTitle = Title
  const leftIcon = !!showBackButton
  const rightIcon = true
  const background = null
  const handleLeftIconClick = () => {
    const event = new CustomEvent('OnBackAction', {
      detail: backActionData
    })
    document.dispatchEvent(event)
  }
  const handleRightIconClick = () => {
    if (
      typeof window !== 'undefined' &&
      typeof window.parent.BillPayRedesignNavigation === 'function'
    ) {
      window.parent.BillPayRedesignNavigation('MYACCOUNTS')
    }
  }
  return (
    <div>
      <USBMobileHeader
        title={pageTitle}
        leftIcon={
          leftIcon && (
            <USBIconArrowLeft
              colorVariant={
                background === 'interaction' ? 'light' : 'interaction'
              }
              size="24"
            />
          )
        }
        rightIcon={
          rightIcon && (
            <USBIconModalClose
              colorVariant={
                background === 'interaction' ? 'light' : 'interaction'
              }
              size="24"
            />
          )
        }
        background={background}
        handleRightIconClick={rightIcon && handleRightIconClick}
        handleLeftIconClick={leftIcon && handleLeftIconClick}
      />
    </div>
  )
}

export default MobileBillPayLayout
